<template>
  <omint-page-content>
    <div class="term-box">
      <OmtTypography as="h1-bold" mb="16px">Identificação de vínculo</OmtTypography>
      <OmtTypography as="h3-semi-bold" mb="24px"
        >Para identificar seu vínculo com a Omint informe seu CPF:
      </OmtTypography>
      <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">CPF</OmtTypography>
      <OmtInput v-model="input" v-mask="'###.###.###-##'" mb="5" />
      <OmtTypography as="p1" color="var(--colors-light-support-error)" v-if="inputError && input.length === 14">
        CPF inválido
      </OmtTypography>
      <br />
    </div>
    <OmtButton
      variant="solid"
      width="100%"
      height="50px"
      border="0.5px solid var(--colors-light-secondary-divider)"
      borderRadius="40px"
      data-cy="button-entrar"
      @click="handleClick()"
      :disabled="input.length != 14 || inputError"
      mb="3"
    >
      <OmtTypography as="h1-bold" color="white">Continuar</OmtTypography>
    </OmtButton>
  </omint-page-content>
</template>

<script>
import Options from "@/components/Molecules/Options";
import { mapState, mapActions } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export default {
  name: "Bond",
  components: { Options },
  mounted() {
    if (!this.hash) {
      this.$router.replace({ name: "first-access.terms" });
      return;
    }
    this.$root.$emit("change-title-label", "Vínculo");
    this.$root.$emit("hide-loading");
  },
  data: function () {
    return {
      selected: "1",
      inputError: false,
      input: ""
    };
  },
  computed: {
    ...mapState("firstAccess", ["autorizador", "hash", "cadastrarBiometria"])
  },
  methods: {
    ...mapActions("firstAccess", ["fetchVinculos"]),
    handleClick: async function () {
      await this.$root.$emit("show-loading");
      const error = await this.fetchVinculos({ cod: this.input });
      await this.$root.$emit("hide-loading");
      if (error) {
        if (error.indexOf("Recuperação de Senha") > 0) {
          Swal.fire({
            title: "Aviso",
            text: error,
            showCancelButton: true,
            confirmButtonText: "Tentar novamente",
            cancelButtonText: "Recuperação de Senha",
            allowEscapeKey: false,
            allowOutsideClick: false
          }).then(result => {
            if (result.value) {
              this.invalidUser = true;
              this.invalidPwd = true;
            } else {
              this.$router.push("/forgot/reset");
            }
          });
        } else {
          Swal.fire({
            title: "Aviso",
            text: error,
            confirmButtonText: "Tentar novamente"
          });
        }
        return;
      }
      if (this.autorizador === "CODIGO") {
        await this.$router.push({
          name: "first-access.mailcheck"
        });
        return;
      }
      await this.$router.push({
        name: this.cadastrarBiometria ? "first-access.biometry-register" : "first-access.biometry-auth"
      });
    },
    validateCPF(cpf) {
      if (!cpf) {
        return false;
      }
      cpf = cpf.replaceAll(/[\s.-]*/gim, "");
      if (
        !cpf ||
        cpf.length !== 11 ||
        cpf === "00000000000" ||
        cpf === "11111111111" ||
        cpf === "22222222222" ||
        cpf === "33333333333" ||
        cpf === "44444444444" ||
        cpf === "55555555555" ||
        cpf === "66666666666" ||
        cpf === "77777777777" ||
        cpf === "88888888888" ||
        cpf === "99999999999"
      ) {
        return false;
      }
      let sum = 0;
      let rest;
      for (let i = 1; i <= 9; i += 1) {
        sum += Number.parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
      }
      rest = (sum * 10) % 11;
      if (rest === 10 || rest === 11) {
        rest = 0;
      }
      if (rest !== Number.parseInt(cpf.substring(9, 10), 10)) {
        return false;
      }
      sum = 0;
      for (let i = 1; i <= 10; i += 1) {
        sum += Number.parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
      }
      rest = (sum * 10) % 11;
      if (rest === 10 || rest === 11) {
        rest = 0;
      }
      if (rest !== Number.parseInt(cpf.substring(10, 11), 10)) {
        return false;
      }
      return true;
    }
  },
  watch: {
    input: function (val) {
      this.inputError = !this.validateCPF(val);
    }
  }
};
</script>

<style lang="scss" scoped>
.term-box {
  height: calc(100vh - 180px);
  overflow-y: auto;
}
</style>
